import React, {useContext, useRef} from 'react';
import classNames from 'classnames';
import shrinkIcon from './../images/backIcon.png';
import logoutIcon from './../images/logoutIcon.png';
import expandIconCropped from './../images/expandIconCropped.png';
import { Link, useLocation, useHistory } from 'react-router-dom';
import video from '../images/video.png';
import homework from '../images/homework.png';
import notes from '../images/Notes.png';
import results from '../images/Results.png';
import VirtualClass from '../images/virtualClass.png';
import Attendance from '../images/Attendance.png';
import Timetable from '../images/Timetable.png';
import { DataContext } from '../context/DataContext';
import { AuthContext } from '../context/AuthContext';
import useOnClick from './common/ClosePopUp'

const navItems = [
  {
    label: 'Video Lessons',
    path: 'video',
    icon: video
  },
  {
    label: 'Homework',
    path: 'homework',
    icon: homework,
  },
  {
    label: 'Notes',
    path: 'notes',
    icon: notes,
  },
  {
    label: 'Check Results',
    path: 'checkResults',
    icon: results,
  },
  {
    label: 'Virtual Classroom',
    path: 'virtualClassroom',
    icon: VirtualClass
  },
  {
    label: 'Attendance ',
    path: 'filterAttendance',
    icon: Attendance
  },
  {
    label: 'Timetable',
    path: 'timetable',
    icon: Timetable
  },
  {
    label: 'Resources',
    path: 'resources',
    icon: Timetable
  } 
];

const NavItem = ({ navItem }) => {
  const dataContext = useContext(DataContext);
  const showMenu = dataContext.showMenu;
  const setDisplaySidebar = () => {
    dataContext.setShowMenu(!showMenu)
  }
  const history = useHistory();

  const location = useLocation();
  const isCurrentRoute =
    location.pathname === `/${navItem.path}`;
  const classes = classNames({
    "py-1 leading-none text-sm leading-4 flex font-semibold mb-3 cursor-pointer": true,
    // 'hidden': localStorage.getItem('schoolDomain') !== 'demo.edves.net' && navItem.label === 'Timetable',
    'text-gray-200 hover:text-blue-100 transform hover:translate-x-1 transition ease-in-out duration-100': !isCurrentRoute,
    'text-blue-100': isCurrentRoute,
    'hidden' : dataContext.hideSidebar === false
  });
  return (
    <div className={`${(((localStorage.getItem('schoolDomain') !== 'demogh.edves.net') && (localStorage.getItem('schoolDomain') !== 'demo.edves.net')) && navItem.label === 'Timetable') && 'hidden'}`}>
      {dataContext.hideSidebar && 
      <Link to={navItem.path} className={classes}>
        <div className={`flex items-center flex-shrink-0`}>
          <div className="mr-4">
            <img src={navItem.icon} alt='icon' /> 
          </div>
          {dataContext.hideSidebar &&
          <span className="block">
            {navItem.label}
          </span>}
        </div>
      </Link>}
      {dataContext.hideSidebar === false && 
        <div onClick={()=>history.push(navItem.path)} className={`w-8 py-1 transform hover:translate-x-1 transition ease-in-out duration-100 mb-3`}>
          <img src={navItem.icon} alt='icon' /> 
        </div>
      }
    </div>
  );
};

const NavItemContainer = ({ children }) => (
  <div>{children}</div>
);

const Sidebar = () => {
  const dataContext = useContext(DataContext);
  const authContext = useContext(AuthContext);
  const showMenu = dataContext.showMenu;
  const setShowMenu = dataContext.setShowMenu
  const history = useHistory();
  const ref = useRef()

  useOnClick(ref, () => dataContext.setShowMenu(false));
  return (
    <>
      {!showMenu && 
      <section className="hidden sidebarHeight sm:block bg-white sm:bg-gray-700 w-48 pl-4 sm:w-48 sm:-mt-8 fixed sidebarHamburgerMargin z-50">
        { dataContext.hideSidebar &&
        <div onClick={() => dataContext.setSideBarHidden(false)} className="hidden sm:flex justify-end">
          {!showMenu && 
          <img src={shrinkIcon} alt="shrink" className="cursor-pointer w-16" /> 
        }
        </div>
        }
        {   dataContext.hideSidebar === false && 
        <div className="hidden sm:flex justify-start">
          {!showMenu && 
          <img onClick={() => dataContext.setSideBarHidden(true)} src={expandIconCropped} alt="shrink" className="cursor-pointer mb-5 mt-1 -ml-2 w-10" /> 
          }
        </div>
        }

        <div className="-mt-1 mx-0 w-full">
          {navItems.map((navItem, i) => (
            <>
              <NavItemContainer key={i}>
                <NavItem navItem={navItem} />
              </NavItemContainer>
            </>
          ))}
        </div>
        <div className='absolute fixedPosition right-0 flex transform hover:translate-x-1 transition ease-in-out duration-100'>
          <img src={logoutIcon} alt='logout' className='mr-5' />
          { dataContext.hideSidebar && 
            <span onClick={() => authContext.logout()} className='text-sm hover:text-blue-100 text-gray-200 font-semibold cursor-pointer leading-5'> 
            Log out 
            </span>
          }
        </div>
      </section>
      }

      {showMenu &&
      <> 
      <section ref={ref} onClick={() => dataContext.setShowMenu(!showMenu)} className="sidebarHeight sm:block bg-white sm:bg-gray-700 w-48 pl-4 pt-4 sm:w-48 mt-0 fixed sidebarHamburgerMargin z-50">
        <div className="-mt-1 mx-0">
          {navItems.map((navItem, i) => (
            <>
              <NavItemContainer key={i}>
                <NavItem navItem={navItem} />
              </NavItemContainer>
            </>
          ))}
            <div className='absolute fixedPosition right-0 mb-4 sm:mb-16 flex cursor-pointer transform hover:translate-x-1 transition ease-in-out duration-100'>
              <img src={logoutIcon} alt='logout' className='mr-4' />
              { dataContext.hideSidebar && 
                <span onClick={() => authContext.logout()} className='text-sm hover:text-blue-100 text-gray-200 font-semibold leading-5 transform hover:translate-x-1 transition ease-in-out duration-100'> 
                Log out 
                </span>
              }
            </div>
        </div>
      </section>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
      }
    </>
    
  );
};

export default Sidebar;
